import SubNavigation from "./SubNavigation.vue"

export default SubNavigation